import React from 'react';

import telegramLogo from '../../assets/images/telegram-logo.svg';
import './styles/TelegramFloatingButton.scss';

const TELEGRAM_URL = 'https://t.me/landlix_support_bot';

export default function TelegramFloatingButton() {
    return (
        <a
            className="telegram-floating-button"
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Написать Landlix в Telegram: @landlix_support_bot"
        >
            <span className="telegram-floating-button__label">
                Связаться с нами
            </span>
            <span className="telegram-floating-button__icon" aria-hidden="true">
                <img
                    src={telegramLogo}
                    alt=""
                />
            </span>
        </a>
    );
}
